export { default } from "./GameManagementEdit";
